export const CATS_ADMIN_CONTROLLER_ROOT_PATH = "/admin";

export const CATS_ADMIN_GET_ALL_PATH_PARAM_USER_ID = "userId";
export const CATS_ADMIN_GET_ALL_PATH_SUFFIX = `/cats/:${CATS_ADMIN_GET_ALL_PATH_PARAM_USER_ID}`;
/** /admin/cats */
export const CATS_ADMIN_GET_ALL_PATH =
  CATS_ADMIN_CONTROLLER_ROOT_PATH + CATS_ADMIN_GET_ALL_PATH_SUFFIX;

export const CATS_ADMIN_UPDATE_DETAILS_PATH_PARAM = "userId";
export const CATS_ADMIN_UPDATE_DETAILS_PATH_SUFFIX = `/cat/update/:${CATS_ADMIN_UPDATE_DETAILS_PATH_PARAM}`;
/** /admin/cat/update/:userId */
export const CATS_ADMIN_UPDATE_DETAILS_PATH =
  CATS_ADMIN_CONTROLLER_ROOT_PATH + CATS_ADMIN_UPDATE_DETAILS_PATH_SUFFIX;

export const CATS_ADMIN_SUPPRESS_CAT_PATH_PARAM = "userId";
export const CATS_ADMIN_SUPPRESS_CAT_SUFFIX = `/cat/suppress/:${CATS_ADMIN_SUPPRESS_CAT_PATH_PARAM}`;
/** /admin/cat/suppress/:userId */
export const CATS_ADMIN_SUPPRESS_CAT_PATH = `${
  CATS_ADMIN_CONTROLLER_ROOT_PATH
}${
  CATS_ADMIN_SUPPRESS_CAT_SUFFIX
}`;
